/* 🤖 this file was generated by svg-to-ts */
export var spxIconAlertCircle = {
    name: 'alert_circle',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1.25 1.25)\"><g><circle cx=\"10.75\" cy=\"10.75\" r=\"10\" stroke-width=\"1.5\"/><path d=\"M10.742 13.75H10.751\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M10.75 10.75L10.75 6.75\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g></g></svg>"
};
